import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { MainService } from '@english/service/main.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/

  public SwiperConfigInterface_news: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  };

  public boardData: any = [];

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    private mainService: MainService,
  ) { }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit() {
    // // 상단이동
    // window.scroll({
    //   top: 0,
    //   left: 0
    // });

    this.getBoardInfo();

  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 :
    리턴값 :
  *******************************************************************************/
  getBoardInfo() {
    // 뉴스 가져오기
    const params = {language: 'english'};
    this.mainService.getBoardNews(params).then( response => {
      if ( response.ResultCode ) {
        this.boardData = response.data;
      } else {
        this.boardData = [];
      }
    });
  }

  /*******************************************************************************
    설  명 : li 표시 체크
    입력값 : index, key
    리턴값 :
  *******************************************************************************/
  checkLi( index, key ) {
    if ( index == '' ) index = 0;

    if ( Math.floor( index / 8 ) == (key - 1) ) return true;
    else return false;
  }

  checkLastPage( index ) {
    let tmp = [];
    let last = Math.floor( this.boardData.length / 8 ) + 1;

    for( let i = 0; i < last; i++ ) {
      tmp.push(i + 1);
    }

    return tmp;
  }

  getLastPage( index ) {
    return Math.floor( this.boardData.length / 8 ) + 1;
  }
}
